import { Component } from "@angular/core";

@Component({
  selector: 'app-canteiro-obras-menu',
  templateUrl: './canteiro-obras-menu.component.html',
  styleUrls: ['./canteiro-obras-menu.component.scss']
})
export class CanteiroObrasMenuComponent {
  
}